import { fadeInOut } from "../atoms/Animations";
import { AnimatePresence, motion } from "framer-motion";

export function AlertSuccess({ show, msg }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          variants={fadeInOut}
          initial={"hidden"}
          animate={"visible"}
          exit="exit"
          className="p-16 bg-white border border-gray-200"
        >
          <div className="flex items-center gap-x-8">
            <div className="flex-shrink-0">
              <svg
                width="24"
                height="26"
                viewBox="0 0 24 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M22 14C22 19.5228 17.5228 24 12 24C6.47715 24 2 19.5228 2 14C2 8.47715 6.47715 4 12 4C17.5228 4 22 8.47715 22 14ZM17.5607 11.0607C17.8536 10.7678 17.8536 10.2929 17.5607 10C17.2678 9.70711 16.7929 9.70711 16.5 10L10.0303 16.4697L7.56066 14C7.26777 13.7071 6.79289 13.7071 6.5 14C6.20711 14.2929 6.20711 14.7678 6.5 15.0607L9.5 18.0607C9.79289 18.3536 10.2678 18.3536 10.5607 18.0607L17.5607 11.0607Z"
                  fill="#10B978"
                />
              </svg>
            </div>

            <span className="text-xxs font-medium">{msg}</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export function AlertError({ show, msg }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          variants={fadeInOut}
          initial={"hidden"}
          animate={"visible"}
          exit="exit"
          className="p-16 bg-white border border-gray-200"
        >
          <div className="flex items-center gap-x-8">
            <div className="flex-shrink-0">
              <svg
                width="24"
                height="26"
                viewBox="0 0 24 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M22 14C22 19.5228 17.5228 24 12 24C6.47715 24 2 19.5228 2 14C2 8.47715 6.47715 4 12 4C17.5228 4 22 8.47715 22 14ZM12.75 9C12.75 8.58579 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15V9ZM12.5675 19.5006C12.8446 19.1927 12.8196 18.7185 12.5117 18.4414C12.2038 18.1643 11.7296 18.1893 11.4525 18.4972L11.4425 18.5083C11.1654 18.8162 11.1904 19.2904 11.4983 19.5675C11.8062 19.8446 12.2804 19.8196 12.5575 19.5117L12.5675 19.5006Z"
                  fill="#FF4D4D"
                />
              </svg>
            </div>

            <span className="text-xxs font-medium">{msg}</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
